define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/ManagerModuleLayout.tmpl");

    var Loader = require("ui/loader/Loader");

    var ManagerModuleLayout = {};
    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ManagerModuleLayout = Marionette.Layout.extend({

            template:template,
            className: "manager-module-wrapper",
            loader: null,
            loaderCounter: 0,
            regions:{
                mainRegion:'.manager-main-region'
            },
            showLoader: function(options) {
                if (this.loaderCounter === 0) {
                    this.loader = new Loader(_.extend({
                        permutation: Loader.PERMUTATION.A,
                        zIndex: 999999,
                        el: this.el
                    }, options));
                    this.loader.render();
                }
                this.loaderCounter++;
            },
            closeLoader: function() {
                this.loaderCounter--;
                if (this.loaderCounter === 0) {
                    this.loader.close();
                }

                this.loaderCounter = _.max([this.loaderCounter, 0]);
            }
        });
    });
    return ManagerModuleLayout;
});
